import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter045() {
  return <KbChapterPage slug="chapter-045" />;
}

(Chapter045 as unknown as { path: string }).path = "/theory-album/045";
